import { useState, useMemo } from "react";
import { GridSortModel } from "@mui/x-data-grid";
import { getSortOptionFromModel } from "../utils/sortUtils";

export const useContactsSort = () => {
  const [sortModel, setSortModel] = useState<GridSortModel>([]);

  const currentSortOption = useMemo(() => {
    return getSortOptionFromModel(sortModel);
  }, [sortModel]);

  const handleSortModelChange = (newSortModel: GridSortModel) => {
    setSortModel(newSortModel);
  };

  return {
    sortModel,
    handleSortModelChange,
    currentSortOption,
  };
};
